<template>
  <div class="table-responsive">
    <table class="table table-nowrap table-centered mb-0">
      <thead>
      <tr>
        <th class="border-top-0">Situação/Data</th>
        <th class="border-top-0">Tipo/Número</th>
        <th class="border-top-0">Razão Social/Motivo/Justificativa</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="p in pedidos" :key="p.soc_codigo">
        <td>
          <span v-show="p.soc_status === '1'" class="badge badge-warning font-size-11">Pendente</span>
          <span v-show="p.soc_status  === '2'" class="badge badge-danger font-size-11">Rejeitado</span>
          <span v-show="p.soc_status  === '3'" class="badge badge-info font-size-11">Aprovado</span>
          <p class="text-muted mb-0">{{ p.soc_datahora }}</p>
        </td>
        <td>
          <h5 class="text-truncate font-size-12 mb-1">
            NFS-e
          </h5>
          <router-link
              tag="a"
              :to="{name: 'share-cancelamentos-detalhe', params: {tipo:1, codigo: p.soc_codigo}}">
            {{ p.not_numero }}
          </router-link>
        </td>
        <td>
          <h5 class="text-truncate font-size-12 mb-1">
            {{ p.pes_nome }}
          </h5>
          <p class="text-muted mb-0">{{ p.soc_motivo | motivoCancelamento }}</p>
          <p class="text-muted mb-0">{{ p.soc_justificativa }}</p>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "tabela-cancelamento",
  props: {
    pedidos: {
      type: Array,
      default: function () {
        return [];
      },
    },
  }
}
</script>
